if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindGallery();
      }

      bindGallery() {
        if (this.galleryBound) return;
        this.galleryBound = true;
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.step(button.classList.contains('product-media-modal__nav--next') ? 1 : -1);
          });
        });
        const content = this.querySelector('.product-media-modal__content');
        content?.addEventListener('pointerup', (event) => {
          if (event.target.closest('img')) event.stopPropagation();
        });
        content?.addEventListener('click', (event) => {
          if (event.target.closest('img')) this.classList.toggle('is-zoomed');
        });
        let startX = 0;
        content?.addEventListener(
          'touchstart',
          (event) => {
            startX = event.changedTouches[0].clientX;
          },
          { passive: true }
        );
        content?.addEventListener(
          'touchend',
          (event) => {
            const dx = event.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 48) this.step(dx < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      step(direction) {
        const items = [...this.querySelectorAll('[data-media-id]')];
        if (items.length < 2) return;
        const current = items.findIndex((element) => element.classList.contains('active'));
        const next = items[(current + direction + items.length) % items.length];
        items.forEach((element) => element.classList.remove('active'));
        next.classList.add('active');
        this.classList.remove('is-zoomed');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        const slides = this.querySelectorAll('[data-media-id]');
        this.querySelectorAll('.product-media-modal__nav').forEach((button) => {
          button.hidden = slides.length < 2;
        });
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
